import { useState } from "react";
import { updateInvoice } from "../lib/api";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "./ui/select";
import { Label } from "./ui/label";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "./ui/alert-dialog";
import { toast } from "sonner";

/**
 * Renders a type selector (Adelanto / Final) shown only when editing an existing invoice.
 * On change, persists the new type and reloads the page so the correct form is loaded.
 */
export default function InvoiceTypeSwitcher({ invoiceId, currentType }) {
  const [pendingType, setPendingType] = useState(null);
  const [confirming, setConfirming] = useState(false);

  if (!invoiceId) return null;

  const handleChange = (val) => {
    if (val === currentType) return;
    setPendingType(val);
    setConfirming(true);
  };

  const confirm = async () => {
    try {
      await updateInvoice(invoiceId, { type: pendingType });
      toast.success(`Tipo cambiado a ${pendingType === "advance" ? "Adelanto" : "Final"}`);
      // Reload so the EditRouterWrapper picks the new type and mounts the right form
      window.location.reload();
    } catch (e) {
      toast.error("Error cambiando el tipo: " + (e?.response?.data?.detail || e.message));
      setConfirming(false);
      setPendingType(null);
    }
  };

  return (
    <>
      <div className="flex items-center gap-2">
        <Label className="text-xs font-medium text-slate-600 whitespace-nowrap">Tipo</Label>
        <Select value={currentType} onValueChange={handleChange}>
          <SelectTrigger data-testid="invoice-type-switcher" className="h-8 w-32 text-xs">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="advance" data-testid="type-option-advance">Adelanto</SelectItem>
            <SelectItem value="final" data-testid="type-option-final">Final</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <AlertDialog open={confirming} onOpenChange={(o) => !o && (setConfirming(false), setPendingType(null))}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>¿Cambiar tipo de factura?</AlertDialogTitle>
            <AlertDialogDescription>
              Esta factura pasará de <strong>{currentType === "advance" ? "Adelanto" : "Final"}</strong> a{" "}
              <strong>{pendingType === "advance" ? "Adelanto" : "Final"}</strong>. Las líneas existentes se mantienen.
              Se guardará y se recargará el editor.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="type-switch-cancel">Cancelar</AlertDialogCancel>
            <AlertDialogAction onClick={confirm} className="bg-slate-900 hover:bg-slate-800" data-testid="type-switch-confirm">
              Cambiar y recargar
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
